// extracted by mini-css-extract-plugin
module.exports = {"messageDivisorStartingValue":"ValidationMessages_messageDivisorStartingValue__6XryX","containerIconError":"ValidationMessages_containerIconError__15DkS"};